export const FILE_SHARE_LOADING_STATE = {
    LOADING: 'FILE_SHARE_LOADING',
    READY: 'FILE_SHARE_READY',
}

export const FILE_SHARE_MESSAGE_MAP = {
    [FILE_SHARE_LOADING_STATE.LOADING]: "",
    [FILE_SHARE_LOADING_STATE.READY]: "",
}